import { render, staticRenderFns } from "./DisposalMethodModal.vue?vue&type=template&id=40948532&scoped=true&"
import script from "./DisposalMethodModal.vue?vue&type=script&lang=js&"
export * from "./DisposalMethodModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40948532",
  null
  
)

export default component.exports